import { render, staticRenderFns } from "./HLQHead.vue?vue&type=template&id=b6fc04ce&scoped=true"
import script from "./HLQHead.vue?vue&type=script&lang=js"
export * from "./HLQHead.vue?vue&type=script&lang=js"
import style0 from "./HLQHead.vue?vue&type=style&index=0&id=b6fc04ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fc04ce",
  null
  
)

export default component.exports